var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"t-lk-photos-item",attrs:{"to":_vm.item.link}},[(_vm.item.img)?_c('img',{staticClass:"t-lk-photos-item__img",attrs:{"src":_vm.item.img,"alt":_vm.item.name}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"t-lk-photos-item__content"},[_c('div',{staticClass:"t-lk-photos-item__name"},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',{staticClass:"t-lk-photos-item__date"},[_vm._v(_vm._s(_vm.item.date))])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/lk-photos-item/lk-photos-item.vue?vue&type=template&id=b0117364&
// module id = 1401
// module chunks = 0